import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerMavenProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerMavenProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--no-overflow">
          <div className="phone--font--h7">{'<dependency>'}</div>
          <div className="phone--font--h7">
            &nbsp;&nbsp;&nbsp;&nbsp;
            {'<groupId>' + component.coordinate1 + '</groupId>'}
          </div>
          <div className="phone--font--h7">
            &nbsp;&nbsp;&nbsp;&nbsp;
            {'<artifactId>' + component.coordinate2 + '</artifactId>'}
          </div>
          <div className="phone--font--h7">
            &nbsp;&nbsp;&nbsp;&nbsp;
            {'<version>' + version.version + '</version>'}
          </div>
          <div className="phone--font--h7">{'</dependency>'}</div>
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven;
